/** Cache local de dados recentes para modo offline (FASE-05-T17). */

const STORAGE_KEY = "evolua.pwa.offline-snapshot";

export type OfflineSnapshot = {
  updatedAt: string;
  holerite: {
    competence: string;
    netPayLabel: string;
  };
  vacation: {
    balanceDays: number;
  };
};

const DEMO_SNAPSHOT: OfflineSnapshot = {
  updatedAt: new Date().toISOString(),
  holerite: {
    competence: "07/2026",
    netPayLabel: "R$ 4.280,00",
  },
  vacation: {
    balanceDays: 18,
  },
};

export function readOfflineSnapshot(): OfflineSnapshot | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as OfflineSnapshot;
  } catch {
    return null;
  }
}

/** Persiste snapshot visto recentemente. */
export function writeOfflineSnapshot(snapshot: OfflineSnapshot = DEMO_SNAPSHOT): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...snapshot, updatedAt: new Date().toISOString() }),
  );
}

export function ensureDemoOfflineSnapshot(): OfflineSnapshot {
  const existing = readOfflineSnapshot();
  if (existing) return existing;
  writeOfflineSnapshot(DEMO_SNAPSHOT);
  return DEMO_SNAPSHOT;
}

function formatCompetenceLabel(competence: string): string {
  const [year, month] = competence.split("-");
  if (!year || !month) return competence;
  return `${month}/${year}`;
}

function formatCurrencyLabel(amount: number): string {
  return amount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

/** Grava snapshot a partir do dashboard /me (dados reais da sessão). */
export function writeOfflineSnapshotFromMeDashboard(data: {
  lastPayslip?: {
    competence: string;
    netAmount: number;
  } | null;
  vacationBalance?: {
    balanceDays: number;
  } | null;
}): OfflineSnapshot {
  const existing = readOfflineSnapshot() ?? DEMO_SNAPSHOT;
  const snapshot: OfflineSnapshot = {
    updatedAt: new Date().toISOString(),
    holerite: data.lastPayslip
      ? {
          competence: formatCompetenceLabel(data.lastPayslip.competence),
          netPayLabel: formatCurrencyLabel(data.lastPayslip.netAmount),
        }
      : existing.holerite,
    vacation: data.vacationBalance
      ? { balanceDays: data.vacationBalance.balanceDays }
      : existing.vacation,
  };
  writeOfflineSnapshot(snapshot);
  return snapshot;
}
